import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import ArrowIcon from "../icons/Arrow";

const HEIGHT = "h-[56px]";

const PageHeader = ({ title, fallback = "/account/telegram" }) => {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  useEffect(() => {
    const backButton = window.Telegram?.WebApp?.BackButton;
    backButton?.show();
    backButton?.onClick(goBack);
    return () => {
      backButton?.offClick(goBack);
      backButton?.hide();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <header
        className={`w-full flex justify-center fixed z-[100] top-0 left-0 border-b border-b-slate-200 backdrop-blur-sm bg-white/90 ${HEIGHT}`}
      >
        <div className="w-[92%] max-w-[600px] flex items-center gap-4">
          <button
            onClick={goBack}
            aria-label="Back"
            className="flex items-center justify-center text-[#664bc7] shrink-0 -ml-1"
          >
            <ArrowIcon styles="w-6 h-6 rotate-180" />
          </button>
          <h1 className="text-base sm:text-lg font-semibold text-[#3d5984] truncate">
            {title}
          </h1>
        </div>
      </header>
      <div className={HEIGHT} />
    </>
  );
};

export default PageHeader;
